export default "__VITE_ASSET__2b1c5174__"